var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 29,
    viewBox: "0 0 42 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_72_194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.2998 0.0499878V20.9L37.2898 20.91H4.02979V0.0499878H37.2998Z",
    fill: "#2E4593"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2998 18.73V20.9L37.2898 20.91H33.8298L23.6198 14.5L22.5998 13.86L21.3898 13.11L20.9898 12.85L19.7598 12.08L19.2998 11.79L18.9198 11.56L18.1498 11.07L17.8998 10.92L17.5198 10.68L13.8998 8.40001L12.2698 7.38001L4.02979 2.22001V0.0500098L4.05979 0.0100098L4.11979 0.0500098H7.48979L17.8998 6.57001L18.9198 7.21001L19.1898 7.38001L20.8198 8.40001L20.9898 8.51001L21.6098 8.90001L22.5998 9.52001L22.7698 9.63001L23.6198 10.16L24.4498 10.68L26.6898 12.08L28.3298 13.11L37.2998 18.73Z",
    fill: "#FCF5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2998 20.84L37.3098 20.92L35.0798 20.91L23.6198 13.72L22.6398 13.11L22.5998 13.08L21.6098 12.46L21.0198 12.08L19.9298 11.4L18.9198 10.77L18.7798 10.68L18.1498 10.29L17.8998 10.13L15.1498 8.4L13.5198 7.38L4.02979 1.43V0L4.05979 0.01L4.11979 0.05L15.8298 7.38L17.4498 8.4L17.8998 8.68L18.9198 9.33L19.2998 9.57L19.9298 9.96L21.0798 10.68L22.5998 11.63L22.7698 11.74L23.3198 12.08L23.6198 12.27L24.9498 13.11L37.2998 20.84Z",
    fill: "#F42525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2998 0.459988V2.62999L29.7098 7.37999L28.0798 8.39999L24.4498 10.68L23.6198 11.2L22.7698 11.74L22.5998 11.84L22.2098 12.08L21.6098 12.46L20.9898 12.85L20.5798 13.11L18.9198 14.15L17.8998 14.79L8.13978 20.91H4.02979V19.14L13.6498 13.11L15.2798 12.08L17.5198 10.68L17.8998 10.45L18.1498 10.29L18.9198 9.79999L19.2998 9.56999L20.9898 8.50999L21.1498 8.39999L22.5998 7.49999L22.7798 7.37999L23.6198 6.85999L34.4898 0.0499878H37.0398L37.2998 0.459988Z",
    fill: "#FCF5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2098 0.569988L26.3398 7.37999L24.7098 8.39999L23.6198 9.08999L22.7698 9.62999L22.5998 9.72999L21.0798 10.68L19.9298 11.4L19.2998 11.79L18.9198 12.04L18.8398 12.08L17.8998 12.68L17.2098 13.11L4.77979 20.91H4.02979V19.93L14.9098 13.11L16.5398 12.08L17.8998 11.23L18.1498 11.07L18.7798 10.68L18.9198 10.59L19.9298 9.95999L21.6098 8.89999L22.3998 8.39999L22.5998 8.27999L23.6198 7.63999L24.0298 7.37999L35.7298 0.0499878H36.8898H37.2998V0.499988L37.2098 0.569988Z",
    fill: "#F42525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.31 7.38H4V13.1H37.31V7.38Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.31 8.40002H4V12.08H37.31V8.40002Z",
    fill: "#F42525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5999 0.0499878H18.9199V20.91H22.5999V0.0499878Z",
    fill: "#CD002A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5901 13.11H23.6101V20.91H17.8901V13.11H18.9101V7.37999H17.8901V0.0499878H23.6101V7.37999H22.5901V13.11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6101 0.0499878H18.8901V20.91H22.6101V0.0499878Z",
    fill: "#F42525"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_72_194",
    x: 0,
    y: 0,
    width: 41.3101,
    height: 28.92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_72_194"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_72_194",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUk);
export default __webpack_public_path__ + "static/media/uk.6f8f20a823acb003167203519a99ca18.svg";
export { ForwardRef as ReactComponent };